export enum ElementImportance {
    Required = 0,
    Preferred = 1,
    Optional = 2
}
